import { render, staticRenderFns } from "./CallbackForm.vue?vue&type=template&id=3445ebf2&scoped=true&"
import script from "./CallbackForm.vue?vue&type=script&lang=ts&"
export * from "./CallbackForm.vue?vue&type=script&lang=ts&"
import style0 from "./CallbackForm.vue?vue&type=style&index=0&id=3445ebf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445ebf2",
  null
  
)

export default component.exports